import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AGENTROLE, SUPERVISORROLE } from '../../constants';
import { selectCurrentEmpid, selectCurrentRole } from '../../pages/login/authSlice';
import {
    useGetAgentDataQuery,
    useGetEmployeeMetricStatusQuery,
} from '../../pages/metricdashboard/metricDashboardSlice';
import { saveSCfilDate, loadSCfilDate } from '../../utils/dateStorage';

// import CoachingToDo from '../CoachingToDo/CoachingToDo';

interface GreetingsPropTypes {
    agentnumber: number;
    setAgentNumber: (e: number) => void;
    metricStatusDataFilter: (e: []) => void;
    metricStatusIsFetchingValue: (e: number) => void;
    agentData: (e: []) => void;
    inputmonth: number;
    setInputMonth: (e: number) => void;
    inputyear: number;
    setInputYear: (e: number) => void;
    scorecardVersionValue: (e: number) => void;
}

export const MyMetricGreetingFilter = ({
    agentnumber,
    setAgentNumber,
    metricStatusDataFilter,
    metricStatusIsFetchingValue,
    agentData,
    inputmonth,
    setInputMonth,
    inputyear,
    setInputYear,
    scorecardVersionValue,
}: GreetingsPropTypes) => {
    const [scorecardVersion, setScorecardVersion] = useState(0);
    const { eid, scid, tldate } = useParams();
    const [TLnumber, setTLnumber] = useState<any>();
    const [date, setDate] = useState(new Date());
    const loggedRole = useSelector(selectCurrentRole);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [scorecardDisable, setScorecardDisable] = useState<boolean>(false);
    const [agentDisable, setAgentDisable] = useState<boolean>(false);

    const { data: agentDataValue } = useGetAgentDataQuery(
        {
            employeenumber: parseInt(TLnumber, 10),
            year: inputyear,
            month: inputmonth,
        },
        { skip: !TLnumber } // if TL - false and for Agent - true
    );

    const { data: metricStatusData, isFetching: metricStatusIsFetching } = useGetEmployeeMetricStatusQuery(
        {
            employeenumber: agentnumber ?? 0,
            year: inputyear,
            month: inputmonth,
            scorecardRoleId: 1,
        },
        // { skip: agentDataValue?.data.length === 0 || !agentnumber }
    );

    const DateOnChange = (e: any) => {
        if (!(e.value instanceof Date) || isNaN(e.value.getTime())) return;
        setDate(e.value);
        setInputMonth(e.value.getMonth() + 1);
        setInputYear(e.value.getFullYear());
        saveSCfilDate(e.value);
        window.localStorage.scorecardVersion = '';
        scorecardVersionValue(0);
        if (loggedRole === SUPERVISORROLE) {
            window.localStorage.agentNumber = '';
            setAgentNumber(0);
        }
    };

    const ScorecardOnChange = (e: any) => {
        setScorecardVersion(e.value);
        scorecardVersionValue(e.value);
        window.localStorage.scorecardVersion = e.value;
    };

    const AgentOnChange = (e: any) => {
        setAgentNumber(e.value);
        window.localStorage.agentNumber = e.value;
        window.localStorage.scorecardVersion = '';
    };

    useEffect(() => {
        if (agentDataValue?.data.length > 0) {
            setAgentDisable(false);
            if (window.localStorage.agentNumber) setAgentNumber(window.localStorage.agentNumber);
            else setAgentNumber(agentDataValue?.data[0].agent_number);
        } else {
            setAgentDisable(true);
        }
    }, [agentDataValue]);

    useEffect(() => {
        metricStatusIsFetchingValue(metricStatusIsFetching);
        metricStatusDataFilter(metricStatusData);
        agentData(agentDataValue);
        if (metricStatusData?.data?.length > 0) {
            setScorecardDisable(false);
            if (window.localStorage.scorecardVersion) {
                setScorecardVersion(parseInt(window.localStorage.scorecardVersion, 10));
                scorecardVersionValue(parseInt(window.localStorage.scorecardVersion, 10));
            } else {
                setScorecardVersion(metricStatusData?.data[0].scorecard_version_id);
                scorecardVersionValue(metricStatusData?.data[0].scorecard_version_id);
            }
        } else {
            setScorecardDisable(true);
        }
    }, [metricStatusData]);

    useEffect(() => {
        if (eid) {
            window.localStorage.agentNumber = eid;
        }
        if (tldate) {
            const storedDate = new Date(`${tldate}`);
            if (storedDate) {
                setDate(storedDate);
                setInputMonth(storedDate.getMonth() + 1);
                setInputYear(storedDate.getFullYear());
                window.localStorage.metricDate = storedDate;
            }
        }
        if (scid) {
            window.localStorage.scorecardVersion = scid;
        }

        if (loggedRole === SUPERVISORROLE) {
            const empid = loggedEmpNum;
            setTLnumber(empid || '');
        } else if (loggedRole === AGENTROLE) {
            const empid = loggedEmpNum;
            setAgentNumber(empid || '');
        }

        if (!tldate) {
            const storedDate = loadSCfilDate();
            if (storedDate) {
                setDate(storedDate);
                setInputMonth(storedDate.getMonth() + 1);
                setInputYear(storedDate.getFullYear());
            }
        }
    }, []);

    return (
        <div className="row mt-3">
            <div className="col-12 d-flex justify-content-end align-items-center gap-2">
                {/* <CoachingToDo /> */}
                <Calendar
                    value={date}
                    onChange={DateOnChange}
                    view="month"
                    maxDate={new Date()}
                    className="custom-calendar me-4"
                    dateFormat="MM, yy"
                    showIcon
                />
                {loggedRole === SUPERVISORROLE ? (
                    <Dropdown
                        disabled={agentDisable}
                        value={agentnumber}
                        onChange={AgentOnChange}
                        options={agentDataValue?.data}
                        optionValue="agent_number"
                        optionLabel="agent_name"
                        placeholder={'No Agents'}
                        className="custom-dropdown me-4"
                    />
                ) : (
                    ''
                )}
                <Dropdown
                    disabled={scorecardDisable}
                    value={scorecardVersion}
                    onChange={ScorecardOnChange}
                    options={metricStatusData?.data}
                    optionValue={'scorecard_version_id'}
                    optionLabel={'scorecard_name'}
                    placeholder={'No Scorecards'}
                    className="custom-dropdown me-4"
                />
            </div>
        </div>
    );
};
